<template>
    <ReplayBannerButton :id="bannerId" :playback-namespace="playbackNamespace" />
</template>

<script lang="ts" setup>
import ReplayBannerButton from "@/components/common/ReplayBannerButton.vue";

const { bannerId, playbackNamespace } = defineProps<{
    bannerId: string;
    playbackNamespace: string;
}>();
</script>
